export default {
  props: {
    lastClosePrice: {},
    price: {
      type: Number,
      default: 0,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
    percent: {
      type: Boolean,
      default: false,
    },
    plainStyle: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: '',
    },
  },
  computed: {
    isPriceEqual() {
      // lastClosePrice === null must be checked so
      // new contracts does show price gain on day 1
      // null must be checked in case parameter is not passed (undefined)
      return this.price === 0 || this.lastClosePrice === null;
    },
    priceDisplay() {
      return (this.fixed) ? Math.abs(this.price).toFixed(2) : `${Math.abs(this.price)}`;
    },
    changeValue() {
      const symbol = this.percent ? '%' : '¢';
      if (this.fixed) {
        return !this.isPriceEqual ? `$${this.priceDisplay}` : 'NC';
      }
      return !this.isPriceEqual ? `${this.priceDisplay}${symbol}` : 'NC';
    },
    objClass() {
      return {
        'market-change-price': true,
        [`market-change-price--${this.theme}`]: this.theme,
        'market-change-price--plain': this.plainStyle,
        'market-change-price--up': (!this.isPriceEqual && this.price > 0),
        'market-change-price--down': (!this.isPriceEqual && this.price < 0),
        'market-change-price--equal': this.isPriceEqual,
        'market-change-price--wide': (this.theme === 'page-market' && this.priceDisplay.length === 1),
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-change-price/market-change-price.js